import React, { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Box, Button, Link, Modal } from "@mui/material";

import SlidingPanel from "react-sliding-side-panel";
import RKTextField from "../../../../../../../Supporting files/RKTextField/RKTextField";
import SelectDropdown from "../../../../../../../Supporting files/SelectDropdown/SelectDropdown";

interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
}

const NewTaxPopup: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
}) => {
 const [taxname, setTaxName] = React.useState("");
 const [rate, setRate] = React.useState("");
 const [taxtype, setTaxType] = React.useState("");
 const taxType_data = [
   { key: "Standard Tax", value: "Standard Tax" },
   { key: "Standard Tax", value: "Standard Tax" },
   { key: "Standard Tax", value: "Standard Tax" },
 ];

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };

  return (
    <SlidingPanel
      type={"right"}
      isOpen={open_status}
      size={75}
      backdropClicked={() => value_update(attrName, false)}
    >
      <div>
        <Grid container spacing={3} alignItems="center">
          <Grid xs={12}>
            <h4 className="mb-0 mt-4 ml-3">New Tax</h4>
          </Grid>

          <Grid xs={12} className="mb-5">
            <hr />
          </Grid>
        </Grid>
        <div className="scrollable_area">
          <Grid container spacing={3}>
            <Grid xs={12}>
              <RKTextField
                class_name="inputField"
                title={"Tax Name"}
                value={taxname}
                attrName={setTaxName}
                value_update={updateMasterState}
                warn_status={false}
              />
            </Grid>
            <Grid xs={12}>
              <RKTextField
                class_name="inputField"
                title={"Rate (%)"}
                value={rate}
                attrName={setRate}
                value_update={updateMasterState}
                warn_status={false}
              />
            </Grid>
            <Grid xs={12}>
              <SelectDropdown
                class_name="inputField"
                title="Tax  Type"
                value={taxtype}
                attrName={setTaxType}
                value_update={updateMasterState}
                dropdown_data={taxType_data}
                warn_status={false}
              />
            </Grid>
          </Grid>
        </div>
        <Grid container spacing={3}>
          <Grid xs={12} className="ctaBtn mt-4">
            <Button
              variant="contained"
              className="submitBtn fixedbtn"
              onClick={() => {}}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </div>
    </SlidingPanel>
  );
};

export default NewTaxPopup;
